export default __webpack_public_path__ + "static/mine-free_medium_2-4b00958237bd695aaada01b6facfb210.png";